import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/fontawesome/lightest/regular/xmark.svg")